import { FormInstance, Table, Tooltip } from "antd";
import { AppPartType } from "../../AppForm/types";
import RenderEditColumn from "../../AppCreate/RenderEditColumn";
import { get } from "lodash";
import { AppSelectionList } from "types/app.type";
import { COLUMN_WIDTH } from "../../AppForm/constants";
import { useEffect, useRef, useState } from "react";
import { Styles } from "./style";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import styled from "styled-components";
import { Link, useMatch } from "react-router-dom";
import Button from "@lhd/components/Button";
import { UI_LABELS } from "@lhd/constants";

type ObjectType = {
  [key: string]: any;
};

interface IProps {
  isDisable?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  nameItem: string;
  isEdit?: boolean;
  isPDF?: boolean;

  form: FormInstance<any>;
  setEditorState: any;
  editorState: ObjectType;
  listFileUploaded: any[];
  setListFileUploaded: (value: any) => void;
  parentRecord: AppPartType;
  isAllowEditColumn?: boolean;
  listUpdateAllowDownload?: any;
  setListUpdateAllowDownload?: React.Dispatch<any>;
  setListFileRemove?: React.Dispatch<any>;
  listFileRemove?: any;
  setAllowDownLoad: React.Dispatch<any>;
  allowDownLoad: any;
  selectionDataList: AppSelectionList;
  isPreview?: boolean;
  dataDeleteRecordTableRef?: any;
  dataSourceAllTable: any;
  onUpdateDataSource?: (newData: any[]) => void;
}

const DraggableRow = styled.tr`
  cursor: move;
  &:hover {
    background: #f5f5f5;
  }
`;

const DragHandle = styled.div`
  cursor: move;
  display: inline-flex;
  align-items: center;
  padding: 4px;
  touch-action: none;
`;

const TableCusTom = (props: IProps) => {
  const {
    item,
    isDisable,
    style,
    preview,
    dataDeleteRecordTableRef,
    dataSourceAllTable,
    isEdit,
    isPDF,
  } = props;
  const [isCollapse, setIsCollapse] = useState(false);
  const initDataSource =
    (dataSourceAllTable && dataSourceAllTable[item.id?.toString() || ""]) || [];
  const [dataSource, setDataSource] = useState(initDataSource);
  const refDataSource = useRef(initDataSource);
  refDataSource.current = dataSource;
  const match = useMatch("/apps/:appid/records/edit/:recordId/:pagination");
  const tableRef = useRef<HTMLDivElement>(null);
  // Function to reorder rows after drag
  const handleDragEnd = (result: any) => {
    if (!result.destination) return;
    // const itemsClone = cloneDeep(refDataSource.current);
    const items = refDataSource.current;
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    items.map((item: any, index: number) => {
      //const rowId = itemsClone[index] ? itemsClone[index].row_id : index;
      item.sort_index = index + 1;
      item.row_id = index + 1;
    });
    // Call your update function here
    setDataSource([...items]);
  };

  const handleAddRow = (index: number) => {
    if (isDisable) return;
    if (dataSource) {
      const dataItemClone = { ...dataSource[index] };
      const dataSourceClone = [...dataSource];
      const newDataSource: any[] = [];
      Object.keys(dataItemClone).forEach((key) => {
        if (
          key !== "key" &&
          key !== "sort_index" &&
          key !== "app_part_id" &&
          key !== "row_id"
        ) {
          dataItemClone[key] = "";
        }
      });
      dataItemClone.ids = [];
      dataSourceClone.map((itemDataSource: any, indexItem: number) => {
        if (indexItem === index) {
          itemDataSource.sort_index = indexItem + 1;
          itemDataSource.row_id = (indexItem + 1).toString();
          dataItemClone.row_id = (indexItem + 2).toString();

          const client_id = dataItemClone.row_id + "_" + Date.now();
          dataItemClone.client_id = client_id;
          dataItemClone.key = `${item.id}-${client_id}`;

          dataItemClone.sort_index = indexItem + 2;

          newDataSource.push(
            {
              ...itemDataSource,
            },
            { ...dataItemClone },
          );
        } else if (indexItem < index) {
          itemDataSource.sort_index = indexItem + 1;
          itemDataSource.row_id = (indexItem + 1).toString();
          newDataSource.push({
            ...itemDataSource,
          });
        } else {
          // indexItem > index
          itemDataSource.sort_index = indexItem + 2;
          itemDataSource.row_id = (indexItem + 2).toString();
          newDataSource.push({
            ...itemDataSource,
          });
        }
      });
      setDataSource([...newDataSource]);
    }
  };

  const handleRemoveRow = (index: number) => {
    if (isDisable) return;
    if (dataSource) {
      const dataSourceClone = [...dataSource];
      const newDataSource = dataSourceClone
        .filter((item: any, indexItem: number) => {
          return indexItem != index;
        })
        ?.map((item: any, indexItem: number) => {
          item.sort_index = indexItem + 1;
          return item;
        });
      setDataSource([...newDataSource]);
      if (dataSource[index]) {
        const client_id = dataSource[index].client_id;
        dataDeleteRecordTableRef?.current?.push(client_id);
      }
    }
  };

  useEffect(() => {
    if (dataSourceAllTable && dataSourceAllTable[item.id?.toString() || ""]) {
      setDataSource([...initDataSource]);
    }
  }, [dataSourceAllTable]);

  useEffect(() => {
    if (
      dataSourceAllTable &&
      dataSourceAllTable[item.id?.toString() || ""] &&
      dataSource.length
    ) {
      dataSourceAllTable[item.id?.toString() || ""] = dataSource;
    }
  }, [dataSource]);

  const handleSetPositionLastCell = () => {
    const lastCells = tableRef.current?.querySelectorAll(
      ".last-cell",
    ) as any as HTMLElement[];

    if (tableRef.current) {
      const container = tableRef.current?.closest(
        ".scroll_internal",
      ) as HTMLDivElement;
      if (!container || !tableRef.current || !lastCells) return;
      const rectContainer = container.getBoundingClientRect();
      const rectTable = tableRef.current?.getBoundingClientRect();
      const rectLastCell = lastCells[0]?.getBoundingClientRect();

      const leftTable = rectTable.left;
      const leftContainer = rectContainer.left;
      const distanceFromRight = leftContainer - leftTable;
      if (distanceFromRight > 0) {
        lastCells?.forEach((lastCell) => {
          lastCell.style.transform = `translateX(${Math.min(
            distanceFromRight,
            rectTable.width - rectLastCell.width,
          )}px)`;
        });
      } else {
        lastCells?.forEach((lastCell) => {
          lastCell.style.transform = `translateX(0px)`;
        });
      }
    }
  };
  useEffect(() => {
    const container = tableRef.current?.closest(
      ".scroll_internal",
    ) as HTMLDivElement | null;
    if (!container) return;

    const controller = new AbortController();
    container.addEventListener("scroll", handleSetPositionLastCell, {
      signal: controller.signal,
    });

    return () => controller.abort();
  }, [dataSource.length]);

  useEffect(handleSetPositionLastCell, [dataSource.length]);

  const bodyRef = useRef({
    wrapper: ({ children }: { children: React.ReactNode }) => {
      return (
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId={`${item.id}-drag`}>
            {(provided) => {
              return (
                <tbody {...provided.droppableProps} ref={provided.innerRef}>
                  {children}
                  {provided.placeholder}
                </tbody>
              );
            }}
          </Droppable>
        </DragDropContext>
      );
    },
    row: ({ index, ...rowProps }: any) => {
      // Ensure index is a number
      const safeIndex = typeof index === "number" ? index : 0;
      return (
        <Draggable
          key={rowProps["data-row-key"] || `row-${safeIndex}`}
          draggableId={(
            rowProps["data-row-key"] || `row-${safeIndex}`
          ).toString()}
          index={safeIndex}
        >
          {(provided, snapshot) => (
            <DraggableRow
              ref={provided.innerRef}
              {...rowProps}
              {...provided.draggableProps}
              style={{
                ...rowProps.style,
                ...provided.draggableProps.style,
                background: snapshot.isDragging ? "#fafafa" : "white",
              }}
            >
              {rowProps.children}
            </DraggableRow>
          )}
        </Draggable>
      );
    },
  }); // i had to read source code of rc-table to understand why it is not working well. that is reason dont remove useMemo

  const components = {
    body: bodyRef.current,
  };
  const columns = [
    {
      className: "last-cell",
      fixed: !isPDF && "left",
      title: (
        <div className="container_collapse_button">
          <Tooltip title={isCollapse ? "表示" : "非表示"}>
            <Button
              className="btn-collapse-table"
              disabled={isDisable}
              onClick={() => {
                if (isDisable) return;
                setIsCollapse(!isCollapse);
              }}
              label={isCollapse ? <span>表示</span> : <span>非表示</span>}
            ></Button>
          </Tooltip>
        </div>
      ),
      render: (_: any, record: any, index: number) => {
        const dataSourceLength = dataSource?.length || 0;
        let indexInsert = 0;
        if (dataSourceLength > 1) {
          indexInsert = index - 1;
        }
        return (
          <div
            className={`action-buttons-container ${isDisable ? "view" : ""} ${
              preview ? "preview" : ""
            }`}
          >
            <Draggable
              key={record.key}
              draggableId={record.key.toString()}
              index={index}
            >
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...(!(preview || isDisable) && provided.dragHandleProps)}
                  className="button sort-button"
                >
                  {UI_LABELS.DRAG_HANDLE}
                </div>
              )}
            </Draggable>
            <div
              className="button remove-button"
              onClick={(e) => {
                if (isDisable || dataSource.length < 2) return;
                handleRemoveRow(index);
              }}
            >
              削除
            </div>
            {!!index && (
              <div
                className={`button insert-button top`}
                onClick={(e) => {
                  if (isDisable) return;
                  handleAddRow(indexInsert);
                }}
              >
                挿入
              </div>
            )}
            {index + 1 === dataSourceLength && (
              <div
                className={`button insert-button bottom`}
                onClick={(e) => {
                  if (isDisable) return;
                  handleAddRow(index);
                }}
              >
                挿入
              </div>
            )}
          </div>
        );
      },
    },
    ...(item.children || [])
      .sort((a, b) => a.item_config_data.x - b.item_config_data.x)
      .map((child, index) => {
        const width = child.item_config_data.w * COLUMN_WIDTH;
        const widthCell = width;
        return {
          title: (
            <div
              style={{
                width: width,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{child.is_hide_name ? "" : child.name}</span>
              </div>
            </div>
          ),
          dataIndex: child?.id,
          key: child?.id,
          width: widthCell,
          render: (_: any, record: any, indexRow: number) => {
            return (
              <div style={{ width }}>
                <RenderEditColumn
                  {...props}
                  indexRow={indexRow}
                  child={child}
                  record={record}
                  parentRecord={item}
                  setEditorState={(state: any) => {
                    props.setEditorState({
                      ...props.editorState,
                      [`${record.key}-${child.id}`]: state,
                    });
                  }}
                />
              </div>
            );
          },
        };
      }),
  ];

  return (
    <Styles
      style={style}
      className={`${isDisable ? "mode_view" : ""} ${
        isCollapse ? "collapse-table" : ""
      } ${isPDF ? "pdf-mode" : ""}`}
    >
      <div
        key={item.id}
        style={style}
        data-grid={item.item_config_data}
        id={item.id}
      >
        {/* {isEdit && (
          <div className="container-btn-to-sheet">
            <Link to={`/apps/${appId}/app-sheets/${recordId}/${item.id}`}>
              <Button type="primary" disabled={false}>
                Bizシート編集
              </Button>
            </Link>
          </div>
        )} */}

        <Table
          ref={tableRef}
          scroll={isPDF ? undefined : { x: "max-content" }}
          style={
            isPDF
              ? {
                  width: "100%",
                  tableLayout: "fixed",
                  overflow: "hidden",
                }
              : {}
          }
          columns={columns as any}
          dataSource={dataSource}
          pagination={false}
          components={components}
          rowKey={(record) => record.key}
          onRow={(record: any, index?: number) => {
            return {
              index,
              "data-row-key": get(dataSource, `[${index}].key`, index || 0),
            } as React.HTMLAttributes<any>;
          }}
        />
      </div>
    </Styles>
  );
};
export default TableCusTom;
